import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import {
  Selector,
  Text,
  PapSelector,
  F2SpanSelector,
} from "../formComponents/formComponents";
import { useTranslation } from "react-i18next";
import UpdatingSpinner from "../ui/UpdatingSpinner";
import {
  findInsertSize,
  getValue,
  calculateFlexPitch,
} from "../../utils/utils";
import { toFraction, toDecimal, toFractionRound } from "../../utils";
import { incrementFraction } from "../../utils/utils";

import {
  idx_data_pitch,
  idx_data_pitch_32,
  idx_data_pitch_16p,
  idx_data_pitch_64,
  idx_data_pitch_32p,
  idx_data_pitch_left,
  idx_data_pitch_left_32,
  idx_data_pitch_left_16p,
  idx_data_pitch_left_64,
  idx_data_pitch_left_32p,
  idx_data_pitch_right,
  idx_data_pitch_right_32,
  idx_data_pitch_right_16p,
  idx_data_pitch_right_64,
  idx_data_pitch_right_32p,
  idx_data_insert_sizes,
  idx_data_insert_sizes_od,
  idx_data_insert_types,
  idx_data_clt,
  idx_data_span_measurement,
  idx_data_span_measurement_32,
  idx_data_span_measurement_16p,
  idx_data_span_measurement_64,
  idx_data_span_measurement_32p,
  idx_data_thumb_insert_sizes,
  idx_data_thumb_insert_types,
  idx_data_thumb_type,
  idx_data_flexibility,
  idx_data_hole_sizes,
  idx_data_angle,
  idx_data_angle_1,
  modal_data_titles,
  idx_data_pap_h,
  idx_data_pap_v,
} from "../db/datafixtures/datafixtures";
import { INSERT_TYPE_BLANK } from "../db/datafixtures/idx_data_insert_types";
import {
  specsheetHandleForm,
  specsheetSVGClickOpen,
  specsheetSetOpenDropdown,
} from "../specsheet/specsheet.redux";
import { idx_data_grip, idx_data_hand } from "../settings/settings.sources";
import { setCustomer } from "../bowlers/bowlers.redux";

const lableStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};
const modalStyle = {
  borderBottom: "transparent",
};
const bodyStyle = {
  borderBottom: "transparent",
  padding: "0rem 1rem 1rem 1rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const formStyle = {
  display: "flex",
  flexWrap: "nowrap",
};

const doubleButtonStyle = {
  width: "40px",
  minWidth: "40px",
  height: "40px",
  border: "none",
  borderRadius: 0,
  background: "#00197b",
  color: "#ffffff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: "0 0 40px",
  padding: 0,
};

const InlineFieldGroup = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  border: 1px solid #d4d4d5;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-within {
    border-color: #00197b;
    box-shadow: 0 0 0 3px rgba(0, 25, 123, 0.12);
  }

  & > div:first-child {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
  }

  input.form-control,
  & input {
    flex: 1 1 auto;
    width: 100%;
    min-width: 0;
    height: 40px;
    padding: 0 12px;
    border: none;
    outline: none;
    box-shadow: none;
    background: transparent;
    font-family: Poppins, sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #00197b;
  }

  input.form-control:focus,
  & input:focus {
    border: none;
    outline: none;
    box-shadow: none;
  }
`;

const inlineInputStyle = {};
const inputStyle = {
  width: "100%",
  height: "30px",
};
const colStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};

const temporalButton = {
  width: "auto",
  height: "auto",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "30%",
};

//oval calculation button start
const ButtonCalculateOvalStyle = {
  borderColor: "white",
  backgroundColor: "#20358c",
  fontSize: "18px",
  height: "3em",
  textTransform: "uppercase",
};

const papUDButtonStyleActive = {
  backgroundColor: "#00147B",
  color: "#FFFFFF",
  border: "none",
};

const papUDButtonStyle = {
  backgroundColor: "#FFFFFF",
  color: "#00000099",
  border: "none",
};

const StyledModal = styled(Modal)`
  .modal-content {
    background-color: #ffffff;
    box-shadow: inset 0 4px 0 ${(p) => p.theme.color.primary},
      0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    border-radius: ${(p) => p.theme.radius.md};
    border: none;
  }
  .modal-header {
    border-bottom: 1px solid ${(p) => p.theme.color.border};
    padding: calc(${(p) => p.theme.spacing.md} + 4px)
      ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.md};
  }
  .modal-body {
    padding: ${(p) => p.theme.spacing.md};
    overflow: visible;
  }
`;

const ModalTitle = styled.span`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeLg};
  font-weight: ${(p) => p.theme.font.weightSemibold};
  color: ${(p) => p.theme.color.primary};
  line-height: 1.2;
`;

const InfoCard = styled.div`
  background: ${(p) => p.theme.color.surfaceAlt};
  border-radius: ${(p) => p.theme.radius.md};
  padding: ${(p) => p.theme.spacing.md};
  width: 100%;
`;

// #854: the cut span could already be worked out from the full span and the
// insert, but only ever behind a setting and only if the fields happened to be
// filled in the right order -- so nobody could tell whether the number in the
// box had been calculated or typed. Asked outright, it is never a guess.
const CutPromptLead = styled.p`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeMd};
  color: ${(p) => p.theme.color.text};
  line-height: 1.4;
  margin: 0 0 ${(p) => p.theme.spacing.sm} 0;
`;

const CutPromptValue = styled.div`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeXl};
  font-weight: ${(p) => p.theme.font.weightBold};
  color: ${(p) => p.theme.color.primary};
  text-align: center;
  margin-bottom: ${(p) => p.theme.spacing.sm};
`;

const CutPromptActions = styled.div`
  display: flex;
  gap: ${(p) => p.theme.spacing.sm};

  button {
    flex: 1 1 0;
  }
`;

const ButtonCalculateOval = ({ className, children, onClick }) => (
  <Button
    type="primary"
    size="large"
    className={className}
    style={ButtonCalculateOvalStyle}
    onClick={onClick}
  >
    {children}
  </Button>
);
//oval calculation button end

/**
 * Every field this modal has a picker for.
 *
 * Kept beside the switch below so the two are corrected together. It is a
 * wider set than the drawing's tappable boxes: the oval numbers, the hand and
 * the grip type have pickers here and no box there, which is exactly what the
 * scan review needs to reach them.
 */
export const PICKABLE_FIELDS = [
  "ball_grip", "bridge", "clt",
  "f1_for", "f1_grip_type", "f1_lat", "f1_od", "f1_rev", "f1_size",
  "f1_span_cut", "f1_span_full", "f1_span_hole_to_hole", "f1_span_outer2_cut",
  "f2_for", "f2_grip_type", "f2_lat", "f2_od", "f2_rev", "f2_size",
  "f2_span_cut", "f2_span_full", "f2_span_hole_to_hole", "f2_span_outer2_cut",
  "hand", "name",
  "thm_flex", "thm_for", "thm_insert_type", "thm_lat_l", "thm_lat_r",
  "thm_od", "thm_offset", "thm_oval_degree", "thm_oval_starting_bit",
  "thm_oval_taper", "thm_oval_width", "thm_rev", "thm_round_taper",
  "thm_size", "thm_type",
];

const ModalRedux = (props) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState("Oval Width");

  const {
    initValues,
    pitchDS,
    pitch_leftDS,
    pitch_rightDS,
    labelsPitchDS,
    labelsPitch_leftDS,
    labelsPitch_rightDS,
    openDropdown,
    showModal,
    specsheetSVGClickOpen,
    span_measurementDS,
    spec_sheet_auto_insert_od,
    spec_sheet_auto_repeat_insert_type,
    spec_sheet_auto_repeat_insert_size,
    spec_sheet_auto_lateral_pitches_clt,
    spec_sheet_auto_lateral_pitches,
    spec_sheet_auto_thumb_pitches,
    spec_sheet_auto_cut_to_cut,
    spec_sheet_auto_fill_bridge,
    specsheetHandleForm,
    specsheetSetOpenDropdown,
    isOval,
    isOvalCalculationVisible,
    angle_measurement,
    updatingValues,
    isEdit = false,
    state,
    pap_h,
    pap_v,
    pap_ud,
    bowler,
    setCustomer,
    appSettings,
    vacu_increment,
    isOvalWidthDecimal,
    span_measurement,
    spanMeasurement,
    insertOptions,
    // Optional, and absent everywhere except the scan review. Given them, the
    // same 48 pickers edit a caller's values instead of the live sheet; the
    // bowler screen passes none of them and behaves exactly as it always has.
    onCommit,
    onClose,
    onCommitBowler,
  } = props;
  const [error, setError] = useState("");
  const [localValues, setLocalValues] = useState(initValues);
  // The cut span the driller has chosen to type by hand this time round.
  // Cleared whenever a different picker opens, so the prompt comes back.
  const [manualCutField, setManualCutField] = useState(null);
  const [papLocalValues, setPapLocalValues] = useState(bowler);
  const ovalDiffRef = useRef(null);

  const localInitValues = {
    ...initValues,
    f2_span_full_difference: initValues
      ? toFraction(
          5 / 16 -
            (toDecimal(initValues.f2_span_full || "0", spanMeasurement) -
              toDecimal(initValues.f1_span_full || "0", spanMeasurement))
        )
      : "",
  };

  const display_measurement = appSettings.systemDefault.display_measurement;
  const display_f2_span_full_difference =
    appSettings.systemDefault.display_f2_span_full_difference;
  const pitchFields = [
    "f1_lat",
    "f1_rev",
    "f1_for",
    "f2_lat",
    "f2_rev",
    "f2_for",
    "thm_lat_l",
    "thm_rev",
    "thm_for",
    "thm_lat_r",
  ];
  //Form Finger
  const pitchSelectDS = pitchDS.map((pitch) => ({
    text:
      display_measurement === "decimal" &&
      pitchFields.includes(openDropdown) &&
      pitch.fraction !== "---"
        ? `${pitch.fraction} (${(pitch.decimal * 1).toFixed(3)})`
        : pitch.fraction,
    value: pitch.fraction,
  }));
  const pitchSelectDifferenceDS = pitchDS
    .filter((pitch) => pitch.decimal * 1 <= 1 / 2)
    .map((pitch) => ({
      text:
        display_measurement === "decimal" && pitch.fraction !== "---"
          ? `${pitch.fraction} (${(pitch.decimal * 1).toFixed(3)})`
          : pitch.fraction,
      value: pitch.fraction,
    }));

  const pitchLeftSelectDS = pitch_leftDS.map((pitch) => ({
    text:
      display_measurement === "decimal" && pitch.fraction !== "---"
        ? `${pitch.fraction} (${(pitch.decimal * 1).toFixed(3)})`
        : pitch.fraction,
    value: pitch.fraction,
  }));

  const pitchRightSelectDS = pitch_rightDS.map((pitch) => ({
    text:
      display_measurement === "decimal" && pitch.fraction !== "---"
        ? `${pitch.fraction} (${(pitch.decimal * 1).toFixed(3)})`
        : pitch.fraction,
    value: pitch.fraction,
  }));

  const idx_data_insert_typesDS = idx_data_insert_types
    .filter((type) => {
      // Check if the type exists in any of the insertOptions arrays
      const existsInInsertOptions = Object.values(insertOptions).some((group) =>
        group.some((item) => item.name === type.type && item.use === false)
      );
      //console.log(Object.values(insertOptions));
      // Include the type only if it does not exist in insertOptions with use === false
      return !existsInInsertOptions;
    })
    .slice() // Create a shallow copy to avoid mutating the original array
    .sort((a, b) => {
      // Exception to place "No Inserts" at the top
      if (a.type === "No inserts") return -1;
      if (b.type === "No inserts") return 1;
      return a.type.localeCompare(b.type); // Default alphabetical sorting
    })
    .map((type) => ({
      text: type.type,
      value: type.type,
    }));

  const f1_grip_type = R.find(
    R.propEq("type", R.pathOr("", ["f1_grip_type"])(localInitValues))
  )(idx_data_insert_types);

  const f1_idx_data_insert_sizesDS = R.pipe(
    R.filter(R.propEq("type_id", R.path(["id"])(f1_grip_type))),
    R.map((size) => ({
      text:
        display_measurement !== "decimal"
          ? size.size
          : `${size.size} ${size.size === "---" ? "" : `(${size.decimal})`}`,
      value: size.size,
    }))
  )(idx_data_insert_sizes);

  const getInsertSizes = (gridType) =>
    R.pipe(R.filter(R.propEq("type_id", R.path(["id"])(gridType))));

  const getInsertSize = (gridType, insertSize) =>
    R.pipe(
      R.filter(R.propEq("type_id", R.path(["id"])(gridType))),
      R.filter(R.propEq("size", insertSize)),
      (idx_data_insert_size) => idx_data_insert_size[0]
    );

  const f2_grip_type = R.find(
    R.propEq("type", R.pathOr("", ["f2_grip_type"])(localInitValues))
  )(idx_data_insert_types);

  const f2_idx_data_insert_sizesDS = R.pipe(
    R.filter(R.propEq("type_id", R.path(["id"])(f2_grip_type))),
    R.map((size) => ({
      text:
        display_measurement !== "decimal"
          ? size.size
          : `${size.size} ${size.size === "---" ? "" : `(${size.decimal})`}`,
      value: size.size,
    }))
  )(idx_data_insert_sizes);

  const idx_data_insert_sizes_od_DS = idx_data_insert_sizes_od.map((size) => ({
    text:
      display_measurement !== "decimal"
        ? size.size
        : `${size.size} ${size.size === "---" ? "" : `(${size.decimal})`}`,
    value: size.size,
  }));

  const idx_data_clt_DS = idx_data_clt.map((clt) => ({
    text: clt.angle,
    value: clt.angle,
  }));
  //Form Ruler
  const span_measurementSelectDS = span_measurementDS.map((measure) => ({
    text:
      display_measurement !== "decimal"
        ? measure.fraction
        : `${measure.fraction} ${
            measure.fraction === "---" ? "" : `(${measure.decimal})`
          }`,
    value: measure.fraction,
  }));

  //Form Thumb
  const idx_data_thumb_insert_typesDS = idx_data_thumb_insert_types
    .filter((type) => {
      // Check if the type exists in any of the insertOptions arrays
      const existsInInsertOptions = Object.values(insertOptions).some((group) =>
        group.some((item) => item.name === type.type && item.use === false)
      );
      //console.log(Object.values(insertOptions));
      // Include the type only if it does not exist in insertOptions with use === false
      return !existsInInsertOptions;
    })
    .slice() // Create a shallow copy to avoid mutating the original array
    .sort((a, b) => {
      // Exception to place "No Inserts" at the top
      if (a.type === "No inserts") return -1;
      if (b.type === "No inserts") return 1;
      return a.type.localeCompare(b.type); // Default alphabetical sorting
    })
    .map((type) => ({
      text: type.type,
      value: type.type,
    }));

  const thm_insert_type = R.find(
    R.propEq("type", R.pathOr("", ["thm_insert_type"])(localInitValues))
  )(idx_data_thumb_insert_types);

  const idx_data_hole_sizes_DS = idx_data_hole_sizes.map((size) => ({
    text:
      display_measurement !== "decimal"
        ? size.size
        : `${size.size} ${size.size === "---" ? "" : `(${size.decimal})`}`,
    value: size.size,
  }));

  const thm_idx_data_insert_sizesDS = !thm_insert_type?.select_size
    ? R.pipe(
        R.filter(R.propEq("type_id", R.path(["id"])(thm_insert_type))),
        R.map((size) => ({
          text:
            display_measurement !== "decimal"
              ? size.size
              : `${size.size} ${
                  size.size === "---" ? "" : `(${size.decimal})`
                }`,
          value: size.size,
        }))
      )(idx_data_thumb_insert_sizes)
    : idx_data_hole_sizes_DS;

  const thm_idx_data_insert_sizes_od_DS = thm_insert_type?.select_od
    ? R.pipe(
        R.filter(R.propEq("type_id", R.path(["id"])(thm_insert_type))),
        R.map((size) => size.od),
        R.dropRepeats,
        R.map((od) => ({
          text: od,
          value: od,
        }))
      )(idx_data_thumb_insert_sizes)
    : [];

  const idx_data_thumb_type_DS = idx_data_thumb_type.map((type) => ({
    text: type.type,
    value: type.type,
  }));

  const idx_data_flexibility_DS = idx_data_flexibility.map((flexibility) => ({
    text: flexibility.flexibility,
    value: flexibility.flexibility,
  }));

  const idx_data_angle_DS =
    angle_measurement === "1"
      ? idx_data_angle_1.map((angle) => ({
          text: angle.angle,
          value: angle.angle,
        }))
      : idx_data_angle.map((angle) => ({
          text: angle.angle,
          value: angle.angle,
        }));

  // Pap v and h
  const idx_data_pap_h_DS = idx_data_pap_h.map((pap_h) => ({
    text: pap_h.pap_h,
    value: pap_h.pap_h,
  }));
  const idx_data_pap_v_DS = idx_data_pap_v.map((pap_v) => ({
    text: pap_v.pap_v,
    value: pap_v.pap_v,
  }));

  useEffect(() => {
    if (openDropdown) {
      const getTitle = modal_data_titles.find((element) =>
        isOvalWidthDecimal && openDropdown === "thm_oval_difference"
          ? element.name === "thm_oval_width"
          : element.name === openDropdown
      );
      if (getTitle?.textLabel) {
        setTitle(getTitle.textLabel);
      } else {
        setTitle(getTitle?.selectorLabel);
      }
    }
  }, [openDropdown]);

  useEffect(() => {
    setLocalValues(initValues);
  }, [initValues]);

  useEffect(() => {
    setManualCutField(null);
  }, [openDropdown]);

  useEffect(() => {
    setPapLocalValues(bowler);
  }, [bowler]);

  const handleClose = () =>
    onClose ? onClose() : specsheetSetOpenDropdown({ openDropdown: "" });

  /**
   * The one way a value leaves this modal.
   *
   * On the bowler screen it lands on the live sheet through redux, as it
   * always has. The scan review has no sheet to land on -- its values are a
   * proposal, sometimes for a bowler who does not exist yet -- so it passes
   * its own onCommit and gets the identical pickers writing somewhere else.
   */
  const commit = (payload) =>
    onCommit ? onCommit(payload.specsheetValues) : specsheetHandleForm(payload);

  // Fires when a picker's own dropdown opens or closes. Redux drives the
  // modal on the bowler screen, so clearing openDropdown there is what shuts
  // it; a caller holding its own field state needs telling instead.
  const closeOnPick = () => (onClose ? onClose() : specsheetSVGClickOpen());

  const change = (field, value) => {
    if (typeof field === "object") {
      const values = { ...localInitValues };
      const result = R.mergeAll([values, field]);
      const clearBlankSelectedValues = (val) => (val === "---" ? "" : val);
      const processedValues = R.mapObjIndexed(clearBlankSelectedValues)(result);

      commit({ specsheetValues: processedValues });
    } else {
      const values = { ...localInitValues };
      values[field] = value;
      const clearBlankSelectedValues = (val) => (val === "---" ? "" : val);
      const processedValues = R.mapObjIndexed(clearBlankSelectedValues)(values);

      commit({
        specsheetValues: processedValues,
        noCloseDropdown: field === "name",
      });
    }
  };

  const changeLocal = (field, value) => {
    if (typeof field === "object") {
      const values = { ...localInitValues };
      const result = R.mergeAll([values, field]);
      const clearBlankSelectedValues = (val) => (val === "---" ? "" : val);
      const processedValues = R.mapObjIndexed(clearBlankSelectedValues)(result);
      setLocalValues(processedValues);
    } else {
      const values = { ...localInitValues };
      values[field] = value;
      const clearBlankSelectedValues = (val) => (val === "---" ? "" : val);
      const processedValues = R.mapObjIndexed(clearBlankSelectedValues)(values);

      setLocalValues(processedValues);
    }
  };

  const click = () => {
    setError("");
    commit({ specsheetValues: localValues });
  };

  const changePap = (field, value) => {
    const values = { ...R.omit(["id", "gallery", "hand"])(localInitValues) };
    if (typeof field === "object") {
      const result = R.mergeAll([values, field]);
      const clearBlankSelectedValues = (val) => (val === "---" ? "" : val);
      const processedValues = R.mapObjIndexed(clearBlankSelectedValues)(result);

      setPapLocalValues({ ...papLocalValues, ...processedValues });
    } else {
      values[field] = value;
      const clearBlankSelectedValues = (val) => (val === "---" ? "" : val);
      const processedValues = R.mapObjIndexed(clearBlankSelectedValues)(values);

      setPapLocalValues({ ...papLocalValues, ...processedValues });
    }
  };

  // The PAP is the bowler's, not the sheet's, so it commits down a different
  // road than every other picker here -- and on the scan review there is no
  // live bowler to write to yet. Same shape as `commit` above: given a
  // handler, it edits the caller's copy; given none, the store's.
  const commitBowler = (next) =>
    onCommitBowler ? onCommitBowler(next) : setCustomer({ bowler: next });

  const clickPap = () => {
    setError("");
    commitBowler({ ...bowler, ...papLocalValues });
  };

  // General handle Form
  const openHandler = {
    values: localInitValues,
    openDropdown,
    onDropdownVisibleChange: () => closeOnPick(),
    onChange: change,
    appSettings,
  };

  const openHandlerPap = {
    values: localInitValues,
    openDropdown,
    onDropdownVisibleChange: () => closeOnPick(),
    onChange: changePap,
  };

  const getAutoCutToCut = (span_full, size, grip_type) => {
    const insert_size = getInsertSize(grip_type, size)(idx_data_insert_sizes);

    const insert_width = toDecimal(
      toFractionRound(insert_size?.widthDecimal || 0, span_measurement),
      spanMeasurement
    );

    const span_cut_decimal =
      toDecimal(span_full, spanMeasurement) - insert_width;

    const span_decimal = span_measurementDS.filter((_, idx) => {
      if (idx === span_measurementDS.length - 1) return false;
      const spanIdx = span_measurementDS[idx];
      const spanNextIdx = span_measurementDS[idx + 1];
      return (
        spanIdx.decimal <= span_cut_decimal &&
        spanNextIdx.decimal > span_cut_decimal
      );
    })[0];

    return span_decimal;
  };

  /**
   * The cut span for one finger, if the sheet has enough to work it out:
   * a full span, an insert type that is not blank, and a size.
   */
  const suggestedCut = (finger) => {
    const grip_type = R.find(
      R.propEq("type", localInitValues[`${finger}_grip_type`])
    )(idx_data_insert_types);
    const span_full = localInitValues[`${finger}_span_full`];
    const size = localInitValues[`${finger}_size`];

    if (
      !grip_type ||
      grip_type.id === INSERT_TYPE_BLANK ||
      !span_full ||
      span_full === "---" ||
      !size ||
      size === "---"
    ) {
      return null;
    }

    return getAutoCutToCut(span_full, size, grip_type)?.fraction || null;
  };

  /**
   * Asks before writing. Choosing "calculate" fills the cut and closes, the
   * same value the auto-suggestion would have produced had the fields been
   * filled in the order it expects; choosing "manually" drops through to the
   * ordinary picker.
   */
  const renderCutSpan = (finger, label) => {
    const field = `${finger}_span_cut`;
    const suggestion = manualCutField === field ? null : suggestedCut(finger);

    if (suggestion) {
      return (
        <>
          <CutPromptLead>{t("message.confirm.cutToCutPrompt")}</CutPromptLead>
          <CutPromptValue>{suggestion}</CutPromptValue>
          <CutPromptActions>
            <Button
              variant="outline-secondary"
              onClick={() => setManualCutField(field)}
            >
              {t("message.confirm.cutToCutManual")}
            </Button>
            <Button variant="primary" onClick={() => change(field, suggestion)}>
              {t("message.confirm.cutToCutCalculate")}
            </Button>
          </CutPromptActions>
        </>
      );
    }

    return (
      <Selector
        values={localInitValues}
        name={field}
        source={span_measurementSelectDS}
        label={label}
        {...openHandler}
      />
    );
  };

  const renderSwitch = (openDropdown) => {
    switch (openDropdown) {
      // Form Finger
      case "f1_lat":
        return (
          <>
            <Selector
              values={localInitValues}
              name={"f1_lat"}
              source={pitchLeftSelectDS}
              labels={labelsPitch_leftDS}
              label={t("form.label.lateral")}
              {...openHandler}
            />
          </>
        );
      case "f1_for":
        return (
          <Selector
            values={localInitValues}
            name={"f1_for"}
            source={pitchSelectDS}
            labels={labelsPitchDS}
            label={t("form.label.forward")}
            noTranslate={true}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              sendData["f1_rev"] = "---";
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f1_rev":
        return (
          <Selector
            values={localInitValues}
            name={"f1_rev"}
            source={pitchSelectDS}
            labels={labelsPitchDS}
            label={t("form.label.reverse")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              sendData["f1_for"] = "---";
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f1_grip_type":
        return (
          <Selector
            values={localInitValues}
            name={"f1_grip_type"}
            source={idx_data_insert_typesDS}
            label={t("form.label.insert_type")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              const f1_grip_type = R.find(R.propEq("type", getValue(value)))(
                idx_data_insert_types
              );
              const f1_size = localInitValues.f1_size;
              let f1_od;

              if (spec_sheet_auto_insert_od) {
                if (f1_grip_type && f1_size && R.trim(f1_size) !== "") {
                  f1_od = findInsertSize(
                    f1_size,
                    getInsertSizes(f1_grip_type)(idx_data_insert_sizes)
                  );

                  if (localInitValues.vacu === "vacu") {
                    f1_od = incrementFraction(f1_od, vacu_increment);
                  }
                  sendData["f1_od"] = f1_od;
                }
              }

              if (
                spec_sheet_auto_repeat_insert_type &&
                (!localInitValues.f2_grip_type ||
                  localInitValues.f2_grip_type === "" ||
                  localInitValues.f2_grip_type.toLowerCase() === "no inserts")
              ) {
                sendData["f2_grip_type"] = f1_grip_type.type;
                if (spec_sheet_auto_insert_od) {
                  sendData["f2_od"] = f1_od;
                }
              }

              if (spec_sheet_auto_cut_to_cut) {
                if (
                  localInitValues.f1_span_full &&
                  f1_grip_type.id !== INSERT_TYPE_BLANK &&
                  localInitValues.f1_size !== "" &&
                  localInitValues.f1_size !== "---"
                ) {
                  const f1_span_decimal = getAutoCutToCut(
                    localInitValues.f1_span_full,
                    localInitValues.f1_size,
                    f1_grip_type
                  );

                  if (f1_span_decimal) {
                    sendData["f1_span_cut"] = f1_span_decimal.fraction;
                  }
                }
              }

              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f1_size":
        return (
          <Selector
            values={localInitValues}
            name={"f1_size"}
            source={f1_idx_data_insert_sizesDS}
            noTranslate={true}
            label={t("form.label.insert_size")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};

              const f1_size = getValue(value);
              let f1_od;

              if (spec_sheet_auto_insert_od) {
                if (
                  f1_grip_type &&
                  f1_size &&
                  R.trim(f1_size) !== "" &&
                  R.trim(f1_grip_type.type).toLowerCase() !== "no inserts"
                ) {
                  f1_od = findInsertSize(
                    f1_size,
                    getInsertSizes(f1_grip_type)(idx_data_insert_sizes)
                  );
                  if (localInitValues.vacu === "vacu") {
                    f1_od = incrementFraction(f1_od, vacu_increment);
                  }

                  sendData["f1_od"] = f1_od;
                }
              }

              if (
                spec_sheet_auto_repeat_insert_size &&
                (!localInitValues.f2_size || localInitValues.f2_size === "")
              ) {
                sendData["f2_size"] = f1_size;

                if (spec_sheet_auto_cut_to_cut) {
                  if (
                    localInitValues.f2_span_full &&
                    f2_grip_type.id !== INSERT_TYPE_BLANK &&
                    f1_size !== "" &&
                    f1_size !== "---"
                  ) {
                    const f2_span_decimal = getAutoCutToCut(
                      localInitValues.f2_span_full,
                      f1_size,
                      f2_grip_type
                    );

                    if (f2_span_decimal) {
                      sendData["f2_span_cut"] = f2_span_decimal.fraction;
                    }
                  }
                }

                if (spec_sheet_auto_insert_od) {
                  sendData["f2_od"] = f1_od;
                }
              }

              if (spec_sheet_auto_cut_to_cut) {
                if (
                  localInitValues.f1_span_full &&
                  f1_grip_type.id !== INSERT_TYPE_BLANK &&
                  f1_size !== "" &&
                  f1_size !== "---"
                ) {
                  const f1_span_decimal = getAutoCutToCut(
                    localInitValues.f1_span_full,
                    f1_size,
                    f1_grip_type
                  );

                  if (f1_span_decimal) {
                    sendData["f1_span_cut"] = f1_span_decimal.fraction;
                  }
                }
              }

              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f1_od":
        return (
          <>
            {!R.isEmpty(R.pathOr("", ["f1_grip_type"])(localInitValues)) &&
            R.pathOr("", ["f1_grip_type"])(localInitValues).toLowerCase() !==
              "no inserts" ? (
              <Selector
                values={localInitValues}
                name={"f1_od"}
                source={idx_data_insert_sizes_od_DS}
                label={t("form.label.insert_OD")}
                {...openHandler}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  name={"f1_oval"}
                  value={localInitValues.f1_oval}
                  label={t("form.label.oval")}
                  onChange={changeLocal}
                />
                <Button onClick={click} style={doubleButtonStyle}>
                  <FontAwesomeIcon icon={["fas", "check"]} />
                </Button>
              </div>
            )}
          </>
        );
      case "bridge":
        return (
          <Selector
            values={localInitValues}
            name={"bridge"}
            source={pitchSelectDS}
            label={t("form.label.bridge")}
            {...openHandler}
          />
        );
      case "clt":
        return (
          <Selector
            values={localInitValues}
            name={"clt"}
            source={idx_data_clt_DS}
            label={t("form.label.clt")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              if (spec_sheet_auto_lateral_pitches_clt) {
                const clt = getValue(value);

                const cltObject = R.find(R.propEq("angle", clt))(idx_data_clt);
                sendData["f1_lat"] = R.pathOr("", ["f1_lat"])(cltObject);
                sendData["f2_lat"] = R.pathOr("", ["f2_lat"])(cltObject);
              }
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f2_lat":
        return (
          <Selector
            values={localInitValues}
            name={"f2_lat"}
            source={pitchRightSelectDS}
            labels={labelsPitch_rightDS}
            label={t("form.label.lateral")}
            {...openHandler}
          />
        );
      case "f2_for":
        return (
          <Selector
            values={localInitValues}
            name={"f2_for"}
            source={pitchSelectDS}
            labels={labelsPitchDS}
            label={t("form.label.forward")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              sendData["f2_rev"] = "---";
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f2_rev":
        return (
          <Selector
            values={localInitValues}
            name={"f2_rev"}
            source={pitchSelectDS}
            labels={labelsPitchDS}
            label={t("form.label.reverse")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              sendData["f2_for"] = "---";
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f2_grip_type":
        return (
          <Selector
            values={localInitValues}
            name={"f2_grip_type"}
            source={idx_data_insert_typesDS}
            label={t("form.label.insert_type")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              if (spec_sheet_auto_insert_od) {
                const f2_size = getValue(value);
                let f2_od;

                if (f2_grip_type && f2_size && R.trim(f2_size) !== "") {
                  f2_od = findInsertSize(
                    f2_size,
                    getInsertSizes(f2_grip_type)(idx_data_insert_sizes)
                  );
                  if (localInitValues.vacu === "vacu") {
                    f2_od = incrementFraction(f2_od, vacu_increment);
                  }

                  sendData["f2_od"] = f2_od;
                }
              }

              if (spec_sheet_auto_cut_to_cut) {
                if (
                  localInitValues.f2_span_full &&
                  f2_grip_type?.id !== INSERT_TYPE_BLANK &&
                  localInitValues.f2_size !== "" &&
                  localInitValues.f2_size !== "---"
                ) {
                  const f2_span_decimal = getAutoCutToCut(
                    localInitValues.f2_span_full,
                    localInitValues.f2_size,
                    f2_grip_type
                  );

                  if (f2_span_decimal) {
                    sendData["f2_span_cut"] = f2_span_decimal.fraction;
                  }
                }
              }

              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f2_size":
        return (
          <Selector
            values={localInitValues}
            name={"f2_size"}
            noTranslate={true}
            source={f2_idx_data_insert_sizesDS}
            label={t("form.label.insert_size")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              const f2_size = getValue(value);
              if (spec_sheet_auto_insert_od) {
                let f2_od;

                if (f2_grip_type && f2_size && R.trim(f2_size) !== "") {
                  f2_od = findInsertSize(
                    f2_size,
                    getInsertSizes(f2_grip_type)(idx_data_insert_sizes)
                  );
                  if (localInitValues.vacu === "vacu") {
                    f2_od = incrementFraction(f2_od, vacu_increment);
                  }

                  sendData["f2_od"] = f2_od;
                }
              }

              if (spec_sheet_auto_cut_to_cut) {
                if (
                  localInitValues.f2_span_full &&
                  f2_grip_type.id !== INSERT_TYPE_BLANK &&
                  f2_size !== "" &&
                  f2_size !== "---"
                ) {
                  const f2_span_decimal = getAutoCutToCut(
                    localInitValues.f2_span_full,
                    f2_size,
                    f2_grip_type
                  );

                  if (f2_span_decimal) {
                    sendData["f2_span_cut"] = f2_span_decimal.fraction;
                  }
                }
              }

              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f2_od":
        return (
          <>
            {!R.isEmpty(R.pathOr("", ["f2_grip_type"])(localInitValues)) &&
            R.pathOr("", ["f2_grip_type"])(localInitValues).toLowerCase() !==
              "no inserts" ? (
              <Selector
                values={localInitValues}
                name={"f2_od"}
                source={idx_data_insert_sizes_od_DS}
                label={t("form.label.insert_OD")}
                {...openHandler}
              />
            ) : (
              <InlineFieldGroup>
                <Text
                  name={"f2_oval"}
                  value={localInitValues.f2_oval}
                  label={t("form.label.oval")}
                  onChange={changeLocal}
                  style={inlineInputStyle}
                />
                <Button onClick={click} style={doubleButtonStyle}>
                  <FontAwesomeIcon icon={["fas", "check"]} />
                </Button>
              </InlineFieldGroup>
            )}
          </>
        );
      // Form Ruler
      case "name":
        return (
          <InlineFieldGroup>
            <Text
              name={"name"}
              label={t("form.label.specsheet_name")}
              value={localInitValues.name}
              {...openHandler}
              onChange={changeLocal}
              style={inlineInputStyle}
            />
            <Button onClick={click} style={doubleButtonStyle}>
              <FontAwesomeIcon icon={["fas", "check"]} />
            </Button>
          </InlineFieldGroup>
        );
      case "hand":
        return (
          <Selector
            values={localInitValues}
            name={"hand"}
            source={idx_data_hand}
            label={t("form.label.bowler_hand_grip_type")}
            {...openHandler}
          />
        );
      case "ball_grip":
        return (
          <Selector
            values={localInitValues}
            name={"ball_grip"}
            source={idx_data_grip}
            label={t("form.label.bowler_grip_type")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              const ball_grip = getValue(value);
              if (spec_sheet_auto_fill_bridge) {
                if (ball_grip === "conventional") {
                  sendData["bridge"] = "3/8";
                } else if (ball_grip === "finger_tip") {
                  sendData["bridge"] = "1/4";
                }
              }

              if (spec_sheet_auto_lateral_pitches) {
                if (ball_grip === "conventional") {
                  sendData["f1_lat"] = "1/4";
                  sendData["f2_lat"] = "5/8";
                } else if (ball_grip === "finger_tip") {
                  sendData["f1_lat"] = "3/8";
                  sendData["f2_lat"] = "1/2";
                }
              }
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f1_span_full":
        return (
          <Selector
            values={localInitValues}
            name={"f1_span_full"}
            source={span_measurementSelectDS}
            label={t("form.label.middle_finger_full")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              const f1_span_full = getValue(value);

              if (spec_sheet_auto_thumb_pitches) {
                if (f1_span_full && localInitValues.thm_flex) {
                  const thm_pitchs = calculateFlexPitch(
                    f1_span_full,
                    localInitValues.thm_flex,
                    span_measurementDS
                  );

                  sendData["thm_for"] = thm_pitchs.thm_for;
                  sendData["thm_rev"] = thm_pitchs.thm_rev;
                }
              }

              if (spec_sheet_auto_cut_to_cut) {
                const f1_grip_type = R.find(
                  R.propEq("type", localInitValues.f1_grip_type)
                )(idx_data_insert_types);
                if (
                  f1_grip_type &&
                  f1_span_full &&
                  f1_grip_type.id !== INSERT_TYPE_BLANK &&
                  localInitValues.f1_size !== "" &&
                  localInitValues.f1_size !== "---"
                ) {
                  const f1_span_decimal = getAutoCutToCut(
                    f1_span_full,
                    localInitValues.f1_size,
                    f1_grip_type
                  );

                  if (f1_span_decimal) {
                    sendData["f1_span_cut"] = f1_span_decimal.fraction;
                  }
                }
              }

              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "f1_span_cut":
        return renderCutSpan("f1", t("form.label.middle_finger_cut"));
      case "f1_span_hole_to_hole":
        return (
          <Selector
            values={localInitValues}
            name={"f1_span_hole_to_hole"}
            source={span_measurementSelectDS}
            label={t("form.label.middle_finger_hole_to_hole")}
            {...openHandler}
          />
        );
      case "f2_span_hole_to_hole":
        return (
          <Selector
            values={localInitValues}
            name={"f2_span_hole_to_hole"}
            source={span_measurementSelectDS}
            label={t("form.label.middle_finger_hole_to_hole")}
            {...openHandler}
          />
        );
      case "f1_span_outer2_cut":
        return (
          <Selector
            values={localInitValues}
            name={"f1_span_outer2_cut"}
            source={span_measurementSelectDS}
            label={t("form.label.middle_finger_outer_to_cut")}
            {...openHandler}
          />
        );
      case "f2_span_full":
        return localInitValues.gridType === "conventional" ||
          !display_f2_span_full_difference ? (
          <Selector
            values={localInitValues}
            name={"f2_span_full"}
            source={span_measurementSelectDS}
            label={t("form.label.ring_finger_full")}
            {...openHandler}
          />
        ) : (
          <F2SpanSelector
            values={localInitValues}
            name={"f2_span_full"}
            source={span_measurementSelectDS}
            label={t("form.label.ring_finger_full")}
            sourceDifference={pitchSelectDifferenceDS}
            labelDifference={t("form.label.ring_finger_full_difference")}
            labelsDifference={labelsPitchDS}
            appSettings={appSettings}
            {...openHandler}
            onChangeDifference={(field, value) => {
              const f2_span_full = toFraction(
                toDecimal(localInitValues.f1_span_full, spanMeasurement) +
                  (5 / 16 - toDecimal(value, spanMeasurement))
              );
              const values = { ...localInitValues };
              values["f2_span_full"] = f2_span_full;
              const clearBlankSelectedValues = (val) =>
                val === "---" ? "" : val;
              const processedValues = R.mapObjIndexed(clearBlankSelectedValues)(
                values
              );

              if (spec_sheet_auto_cut_to_cut) {
                const f2_grip_type = R.find(
                  R.propEq("type", localInitValues.f2_grip_type)
                )(idx_data_insert_types);
                if (
                  f2_grip_type &&
                  f2_span_full &&
                  f2_grip_type.id !== INSERT_TYPE_BLANK &&
                  localInitValues.f2_size !== "" &&
                  localInitValues.f2_size !== "---"
                ) {
                  const f2_span_decimal = getAutoCutToCut(
                    f2_span_full,
                    localInitValues.f2_size,
                    f2_grip_type
                  );

                  if (f2_span_decimal) {
                    processedValues["f2_span_cut"] = f2_span_decimal.fraction;
                  }
                }
              }

              commit({
                specsheetValues: processedValues,
                noCloseDropdown: field === "name",
              });
            }}
          />
        );
      case "f2_span_cut":
        return renderCutSpan("f2", t("form.label.ring_finger_cut"));
      case "f2_span_outer2_cut":
        return (
          <Selector
            values={localInitValues}
            name={"f2_span_outer2_cut"}
            source={span_measurementSelectDS}
            label={t("form.label.ring_finger_outer_to_cut")}
            {...openHandler}
          />
        );
      //Form Thumb
      case "thm_flex":
        return (
          <Selector
            values={localInitValues}
            name={"thm_flex"}
            source={idx_data_flexibility_DS}
            label={t("form.label.flexibility")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              if (spec_sheet_auto_thumb_pitches) {
                const thm_flex = getValue(value);
                if (localInitValues.f1_span_full && thm_flex) {
                  const thm_pitchs = calculateFlexPitch(
                    localInitValues.f1_span_full,
                    thm_flex,
                    span_measurementDS
                  );
                  sendData["thm_for"] = thm_pitchs.thm_for;
                  sendData["thm_rev"] = thm_pitchs.thm_rev;
                }
              }
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "thm_offset":
        return (
          <Selector
            values={localInitValues}
            name={"thm_offset"}
            source={idx_data_pap_v_DS}
            label={t("form.label.offset")}
            {...openHandler}
          />
        );
      case "thm_lat_l":
        return (
          <Selector
            values={localInitValues}
            name={"thm_lat_l"}
            source={pitchSelectDS}
            labels={labelsPitchDS}
            label={t("form.label.left")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              sendData["thm_lat_r"] = "---";
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "thm_for":
        return (
          <Selector
            values={localInitValues}
            name={"thm_for"}
            source={pitchSelectDS}
            labels={labelsPitchDS}
            label={t("form.label.forward")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              sendData["thm_rev"] = "---";
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "thm_rev":
        return (
          <Selector
            values={localInitValues}
            name={"thm_rev"}
            source={pitchSelectDS}
            labels={labelsPitchDS}
            label={t("form.label.reverse")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              sendData["thm_for"] = "---";
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "thm_lat_r":
        return (
          <Selector
            values={localInitValues}
            name={"thm_lat_r"}
            source={pitchSelectDS}
            labels={labelsPitchDS}
            label={t("form.label.right")}
            {...openHandler}
            onChange={(field, value) => {
              let sendData = {};
              sendData["thm_lat_l"] = "---";
              sendData[`${field}`] = value;
              change(sendData);
            }}
          />
        );
      case "thm_insert_type":
        return (
          <Selector
            values={localInitValues}
            name={"thm_insert_type"}
            source={idx_data_thumb_insert_typesDS}
            label={t("form.label.insert_type")}
            {...openHandler}
          />
        );
      case "thm_type":
        return (
          <Selector
            values={localInitValues}
            name={"thm_type"}
            source={idx_data_thumb_type_DS}
            label={t("form.label.type")}
            {...openHandler}
          />
        );
      //oval logic
      case "thm_oval_starting_bit":
        return (
          <Selector
            values={localInitValues}
            name={"thm_oval_starting_bit"}
            source={thm_idx_data_insert_sizesDS}
            label={t("form.label.starting_bit")}
            {...openHandler}
          />
        );
      case "thm_oval_width":
        const thm_oval_starting_bit_decimal = toDecimal(
          localInitValues.thm_oval_starting_bit &&
            localInitValues.thm_oval_starting_bit !== ""
            ? localInitValues.thm_oval_starting_bit
            : "0",
          spanMeasurement
        );
        const idx_data_hole_sizes_DS_filtered = idx_data_hole_sizes_DS.filter(
          (item) => {
            const itemDecimal = toDecimal(item.value, spanMeasurement);
            return itemDecimal >= thm_oval_starting_bit_decimal;
          }
        );

        return (
          <Selector
            values={localInitValues}
            name={"thm_oval_width"}
            source={idx_data_hole_sizes_DS_filtered}
            label={t("form.label.oval_width")}
            {...openHandler}
          />
        );
      case "thm_oval_difference":
        return (
          <>
            <div
              className="row"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div className="col-10" style={{ padding: 0 }}>
                <Form.Control
                  ref={ovalDiffRef}
                  defaultValue={localInitValues.thm_oval_difference}
                  step="0.001"
                  type="number"
                  placeholder=""
                  autoFocus
                  style={inputStyle}
                  name="thm_oval_difference"
                />
              </div>
              <div
                className="col-2"
                style={{ height: 30, padding: 0, paddingLeft: 3 }}
              >
                <Button
                  onClick={() => {
                    setError("");
                    const value = ovalDiffRef.current.value * 1;
                    if (isOvalWidthDecimal) {
                      const thm_oval_starting_bit =
                        localInitValues?.thm_oval_starting_bit || "0";
                      const thm_oval_starting_bit_decimal = toDecimal(
                        thm_oval_starting_bit,
                        spanMeasurement
                      );
                      const thm_oval_width_fraction = toFraction(value);

                      if (thm_oval_starting_bit_decimal <= value) {
                        openHandler.onChange(
                          "thm_oval_width",
                          thm_oval_width_fraction
                        );
                      } else {
                        setError("form.error.oval_width");
                      }
                    } else {
                      const thm_oval_starting_bit =
                        localInitValues?.thm_oval_starting_bit || "0";
                      const thm_oval_width_decimal =
                        toDecimal(thm_oval_starting_bit, spanMeasurement) +
                        value;
                      const thm_oval_width_fraction = toFraction(
                        thm_oval_width_decimal
                      );

                      openHandler.onChange(
                        "thm_oval_width",
                        thm_oval_width_fraction
                      );
                    }
                  }}
                  style={doubleButtonStyle}
                >
                  <FontAwesomeIcon icon={["fas", "check"]} />
                </Button>
              </div>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className="col-12"
                style={{ padding: 0, fontSize: 9, color: "red" }}
              >
                {error !== "" ? t(error) : ""}
              </div>
            </div>
          </>
        );
      case "thm_oval_degree":
        return (
          <Selector
            values={localInitValues}
            name={"thm_oval_degree"}
            source={idx_data_angle_DS}
            label={t("form.label.oval_degree")}
            {...openHandler}
          />
        );
      case "thm_od":
        return (
          <Selector
            values={localInitValues}
            name={"thm_od"}
            source={thm_idx_data_insert_sizes_od_DS}
            label={t("form.label.insert_OD")}
            {...openHandler}
          />
        );
      case "thm_oval_taper":
        const startingBitDecimal = toDecimal(
          localInitValues.thm_oval_starting_bit &&
            localInitValues.thm_oval_starting_bit !== ""
            ? localInitValues.thm_oval_starting_bit
            : "0",
          spanMeasurement
        );

        const idx_data_hole_sizes_DS_filtered_by_starting_bit =
          idx_data_hole_sizes_DS.filter((item) => {
            const itemDecimal = toDecimal(item.value, spanMeasurement);
            return itemDecimal >= startingBitDecimal;
          });
        return (
          <Selector
            values={localInitValues}
            name={"thm_oval_taper"}
            source={idx_data_hole_sizes_DS_filtered_by_starting_bit}
            label={t("form.label.taper_size")}
            {...openHandler}
          />
        );
      case "thm_round_taper":
        const startingBitDecimalRound = toDecimal(
          localInitValues.thm_size && localInitValues.thm_size !== ""
            ? localInitValues.thm_size
            : "0",
          spanMeasurement
        );

        const idx_data_hole_sizes_DS_filtered_by_starting_bit_round =
          idx_data_hole_sizes_DS.filter((item) => {
            const itemDecimal = toDecimal(item.value, spanMeasurement);
            return itemDecimal >= startingBitDecimalRound;
          });
        return (
          <Selector
            values={localInitValues}
            name={"thm_round_taper"}
            source={idx_data_hole_sizes_DS_filtered_by_starting_bit_round}
            label={t("form.label.taper_size")}
            {...openHandler}
          />
        );
      case "thm_size":
        return (
          <Selector
            values={localInitValues}
            name={"thm_size"}
            source={thm_idx_data_insert_sizesDS}
            label={t("form.label.size")}
            {...openHandler}
          />
        );
      case "pap":
        let papValues = {
          pap_h: papLocalValues.pap_h,
          pap_v: papLocalValues.pap_v,
        };
        return (
          <>
            <PapSelector
              {...openHandlerPap}
              values={papValues}
              name={"pap_h"}
              source={idx_data_pap_h_DS}
              label={"H:"}
              onChange={changePap}
            />
            <PapSelector
              {...openHandlerPap}
              values={papValues}
              name={"pap_v"}
              source={idx_data_pap_v_DS}
              label={"V:"}
              onChange={changePap}
            />
            <div style={{ display: "flex", justifyContent: "center" }}>
            <ButtonGroup>
              <Button
                onClick={() => {
                  changePap({ pap_u_d: "Up", pap_ud: "Up" });
                }}
                active={pap_ud === "Up" ? true : false}
                name="pap_ud"
                value="Up"
                style={
                  papLocalValues.pap_ud === "Up"
                    ? papUDButtonStyleActive
                    : papUDButtonStyle
                }
              >
                ▲
              </Button>
              <Button
                onClick={() => {
                  changePap({ pap_u_d: "-", pap_ud: "-" });
                }}
                active={pap_ud === "-" ? true : false}
                name="pap_ud"
                value="-"
                style={
                  papLocalValues.pap_ud === "-"
                    ? papUDButtonStyleActive
                    : papUDButtonStyle
                }
              >
                -
              </Button>
              <Button
                onClick={() => {
                  changePap({ pap_u_d: "Down", pap_ud: "Down" });
                }}
                active={pap_ud === "Down" ? true : false}
                name="pap_ud"
                value="Down"
                style={
                  papLocalValues.pap_ud === "Down"
                    ? papUDButtonStyleActive
                    : papUDButtonStyle
                }
              >
                ▼
              </Button>
              <Button
                onClick={clickPap}
                style={{ ...doubleButtonStyle, marginLeft: 8 }}
              >
                <FontAwesomeIcon icon={["fas", "check"]} />
              </Button>
            </ButtonGroup>
            </div>
          </>
        );
      default:
        return <></>;
    }
  };

  const isTextInputModal =
    openDropdown === "name" || openDropdown === "f2_oval";

  return (
    <>
      <StyledModal
        size={isTextInputModal ? undefined : "sm"}
        show={showModal}
        onHide={handleClose}
        centered
        className={`select-modal ${openDropdown}`}
      >
        <Modal.Header closeButton>
          <ModalTitle>{t(`form.label.${title}`)}</ModalTitle>
        </Modal.Header>
        {updatingValues ? (
          <Modal.Body>
            <InfoCard>
              <UpdatingSpinner />
            </InfoCard>
          </Modal.Body>
        ) : isEdit ? (
          <Modal.Body>
            <InfoCard>
              <Form>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                  style={formStyle}
                >
                  <div className="row">
                    <div className="col-10">
                      <div className="row">
                        <div className="col-2" style={colStyle}>
                          <Form.Label>V: </Form.Label>
                        </div>
                        <div className="col-10">
                          <Form.Control
                            type="text"
                            placeholder="v"
                            autoFocus
                            style={inputStyle}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-2" style={colStyle}>
                          <Form.Label>H: </Form.Label>
                        </div>
                        <div className="col-10">
                          <Form.Control
                            type="text"
                            placeholder="h"
                            autoFocus
                            style={inputStyle}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      <Button onClick={handleClose} style={doubleButtonStyle}>
                        <FontAwesomeIcon icon={["fas", "check"]} />
                      </Button>
                    </div>
                  </div>
                </Form.Group>
              </Form>
            </InfoCard>
          </Modal.Body>
        ) : (
          <Modal.Body>
            <InfoCard>{renderSwitch(openDropdown)}</InfoCard>
          </Modal.Body>
        )}
      </StyledModal>
    </>
  );
};

export const ModalSpecsheets = connect(
  // ownProps is read here rather than left to react-redux's default merge:
  // stateProps win over ownProps, so a caller passing `values` or
  // `openDropdown` would be silently overruled by the store.
  (state, ownProps) => {
    const pitch_measurement =
      state.settings.appSettings.systemDefault.pitch_measurement;
    const span_measurement =
      state.settings.appSettings.systemDefault.span_measurement;

    let span_measurement_round = 16;
    switch (span_measurement) {
      case "16": {
        span_measurement_round = 16;
        break;
      }
      case "16+": {
        span_measurement_round = 32;
        break;
      }
      case "32": {
        span_measurement_round = 32;
        break;
      }
      case "32+": {
        span_measurement_round = 64;
        break;
      }
      case "64": {
        span_measurement_round = 64;
        break;
      }
      case "64+": {
        span_measurement_round = 128;
        break;
      }
      default: {
        span_measurement_round = 16;
        break;
      }
    }
    const display_measurement =
      state.settings.appSettings.systemDefault.display_measurement;

    const span_measurementDS = {
      32: idx_data_span_measurement_32,
      "16+": idx_data_span_measurement_16p,
      64: idx_data_span_measurement_64,
      "32+": idx_data_span_measurement_32p,
    };

    const pitchDS = R.pathOr(idx_data_pitch, [pitch_measurement])({
      32: idx_data_pitch_32,
      "16+": idx_data_pitch_16p,
      64: idx_data_pitch_64,
      "32+": idx_data_pitch_32p,
    });

    const pitch_leftDS = R.pathOr(idx_data_pitch_left, [pitch_measurement])({
      32: idx_data_pitch_left_32,
      "16+": idx_data_pitch_left_16p,
      64: idx_data_pitch_left_64,
      "32+": idx_data_pitch_left_32p,
    });

    const pitch_rightDS = R.pathOr(idx_data_pitch_right, [pitch_measurement])({
      32: idx_data_pitch_right_32,
      "16+": idx_data_pitch_right_16p,
      64: idx_data_pitch_right_64,
      "32+": idx_data_pitch_right_32p,
    });

    const omitEmptyFields = (val) => val !== "";
    const initValues = R.pipe(
      R.pickBy(omitEmptyFields),
      R.omit(["updated_at", "created_at"])
    )(ownProps.values || state.specsheet.currentSpecSheet);
    const isOval = R.path(["thm_type"])(initValues) === "Oval";
    const isOvalWidthDecimal =
      isOval &&
      state.settings.appSettings.thumbHolePreferences.oval_width_difference ===
        "decimal";

    initValues.thm_oval_difference = isOvalWidthDecimal
      ? initValues
        ? toDecimal(initValues?.thm_oval_width, span_measurement).toFixed(3)
        : "0.000"
      : initValues &&
        initValues.thm_oval_width &&
        initValues.thm_oval_width !== "" &&
        initValues.thm_oval_starting_bit &&
        initValues.thm_oval_starting_bit !== ""
      ? (
          toDecimal(initValues.thm_oval_width, span_measurement) -
          toDecimal(initValues.thm_oval_starting_bit, span_measurement)
        ).toFixed(3)
      : initValues &&
        initValues.thm_oval_width &&
        initValues.thm_oval_width !== "" &&
        (!initValues.thm_oval_starting_bit ||
          initValues.thm_oval_starting_bit === "")
      ? toDecimal(initValues.thm_oval_width, span_measurement).toFixed(3)
      : "0.000";

    return {
      initValues,
      enableReinitialize: true,
      spec_sheet_auto_insert_od:
        state.settings.appSettings.autoSuggestions.spec_sheet_auto_insert_od,
      spec_sheet_auto_repeat_insert_type:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_repeat_insert_type,
      spec_sheet_auto_repeat_insert_size:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_repeat_insert_size,
      spec_sheet_auto_lateral_pitches_clt:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_lateral_pitches_clt,
      spec_sheet_auto_fill_bridge:
        state.settings.appSettings.autoSuggestions.spec_sheet_auto_fill_bridge,
      vacu_increment:
        state.settings.appSettings.systemDefault.default_vacu_increment,
      pitchDS,
      pitch_leftDS,
      pitch_rightDS,
      labelsPitchDS:
        pitch_measurement === "16"
          ? idx_data_pitch.reduce((acc, { fraction, decimal }) => {
              const text =
                display_measurement === "decimal" && fraction !== "---"
                  ? `${fraction} (${(decimal * 1).toFixed(3)})`
                  : fraction;

              return {
                ...acc,
                [fraction]: text === "---" ? "" : text,
              };
            }, {})
          : pitch_measurement === "16+"
          ? idx_data_pitch_16p.reduce((acc, { fraction, decimal }) => {
              const text =
                display_measurement === "decimal" && fraction !== "---"
                  ? `${fraction} (${(decimal * 1).toFixed(3)})`
                  : fraction;

              return {
                ...acc,
                [fraction]: text === "---" ? "" : text,
              };
            }, {})
          : pitch_measurement === "32"
          ? idx_data_pitch_32.reduce((acc, { fraction, decimal }) => {
              const text =
                display_measurement === "decimal" && fraction !== "---"
                  ? `${fraction} (${(decimal * 1).toFixed(3)})`
                  : fraction;

              return {
                ...acc,
                [fraction]: text === "---" ? "" : text,
              };
            }, {})
          : pitch_measurement === "32+"
          ? idx_data_pitch_32p.reduce((acc, { fraction, decimal }) => {
              const text =
                display_measurement === "decimal" && fraction !== "---"
                  ? `${fraction} (${(decimal * 1).toFixed(3)})`
                  : fraction;

              return {
                ...acc,
                [fraction]: text === "---" ? "" : text,
              };
            }, {})
          : pitch_measurement === "64"
          ? idx_data_pitch_64.reduce((acc, { fraction, decimal }) => {
              const text =
                display_measurement === "decimal" && fraction !== "---"
                  ? `${fraction} (${(decimal * 1).toFixed(3)})`
                  : fraction;

              return {
                ...acc,
                [fraction]: text === "---" ? "" : text,
              };
            }, {})
          : {},
      labelsPitch_leftDS: idx_data_pitch_left_64.reduce(
        (acc, { fraction, decimal }) => {
          const text =
            display_measurement === "decimal" && fraction !== "---"
              ? `${fraction} (${(decimal * 1).toFixed(3)})`
              : fraction;

          return {
            ...acc,
            [fraction]: text === "---" ? "" : text,
          };
        },
        {}
      ),
      labelsPitch_rightDS: idx_data_pitch_right_64.reduce(
        (acc, { fraction, decimal }) => {
          const text =
            display_measurement === "decimal" && fraction !== "---"
              ? `${fraction} (${(decimal * 1).toFixed(3)})`
              : fraction;

          return {
            ...acc,
            [fraction]: text === "---" ? "" : text,
          };
        },
        {}
      ),
      openDropdown: ownProps.openDropdown ?? state.specsheet.openDropdown,
      showModal:
        (ownProps.openDropdown ?? state.specsheet.openDropdown) !== "",
      state: state,
      span_measurementDS: R.pathOr(idx_data_span_measurement, [
        span_measurement,
      ])(span_measurementDS),
      spec_sheet_auto_thumb_pitches:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_thumb_pitches,
      spec_sheet_auto_cut_to_cut:
        state.settings.appSettings.autoSuggestions.spec_sheet_auto_cut_to_cut,
      spec_sheet_auto_lateral_pitches:
        state.settings.appSettings.autoSuggestions
          .spec_sheet_auto_lateral_pitches,
      //form thumb
      isOvalCalculationVisible:
        isOval &&
        state.settings.appSettings.thumbHolePreferences.oval_calculation !==
          "manual",
      isOval,
      angle_measurement:
        state.settings.appSettings.systemDefault.angle_measurement,
      updatingValues:
        state.specsheet.updatingValues || state.bowlers.updatingCustomerValues,
      // selectedCustomer is null until a bowler is opened, and the batch
      // inbox mounts this from the bowlers list where none ever is. Reading
      // through it unguarded threw there.
      // ownProps wins, so the scan review's proposed bowler is edited rather
      // than whoever happens to be open behind it -- often nobody at all.
      pap_v: (ownProps.bowler ?? state.bowlers.selectedCustomer)?.pap_v,
      pap_h: (ownProps.bowler ?? state.bowlers.selectedCustomer)?.pap_h,
      pap_ud:
        (ownProps.bowler ?? state.bowlers.selectedCustomer)?.pap_u_d ||
        (ownProps.bowler ?? state.bowlers.selectedCustomer)?.pap_ud,
      bowler: ownProps.bowler ?? state.bowlers.selectedCustomer,
      appSettings: state.settings.appSettings,
      isOvalWidthDecimal,
      span_measurement: span_measurement_round,
      spanMeasurement:
        state.settings.appSettings.systemDefault.span_measurement,
      insertOptions: state.settings.appSettings.insertOptions,
    };
  },
  {
    specsheetHandleForm,
    specsheetSVGClickOpen,
    specsheetSetOpenDropdown,
    setCustomer,
  }
)(ModalRedux);
